const language =
    {
        es: {
            requiredError: 'Campo requerido',
            numberRequired: 'Campo debe contener solo números'
        }
    }
export default language;